import React, { useEffect } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
// @ts-ignore-next-line
import smoothscroll from "smoothscroll-polyfill";
import theme, { responsiveDarkTheme, responsiveLightTheme } from "../theme";
import { Provider } from "react-redux";
import store from "../state";
import Checkout, { PaymentFailed } from "./checkout";
import { GA_ID } from "../constants";
import Dashboard from "./dashboard";
import { Links } from "../types";
import ResponsiveMapMaker from "./mapmaker/ResponsiveMapMaker";
import { Box, IconButton } from "@mui/material";
import Preview from "./preview";
import ViewMap from "./map";
import { ThemeProvider, useThemeMode } from "@/colors";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); 
  return <></>
}

// Theme-aware app content component
const AppContent = () => {
  const { colors, mode } = useThemeMode();
  const currentTheme = mode === 'light' ? responsiveLightTheme : responsiveDarkTheme;
  
  // Set the background color on body and html elements
  useEffect(() => {
    document.body.style.backgroundColor = colors.background.brand.lightest;
    document.documentElement.style.backgroundColor = colors.background.brand.lightest;
    
    return () => {
      // Cleanup is optional, but good practice
      document.body.style.backgroundColor = '';
      document.documentElement.style.backgroundColor = '';
    };
  }, [colors.background.brand.lightest]);
  
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      bgcolor={colors.background.brand.lightest}
      minHeight="100vh"
      width="100%"
    >
      <Provider store={store}>
        <BrowserRouter>
          <StyledThemeProvider theme={currentTheme}>
            <MuiThemeProvider theme={currentTheme}>
              <Routes>
                <Route path={Links.Home} element={<Dashboard/>} />
                <Route path={Links.Create} element={<ResponsiveMapMaker/>} />
                <Route path={Links.Checkout} element={<Checkout/>} />
                <Route path={`${Links.Preview}/:token`} element={<Preview/>} />
                <Route path={`${Links.Map}/:token`} element={<ViewMap/>} />
                <Route path={`${Links.Map}/:token`} element={<ViewMap/>} />
                <Route path={Links.PaymentFailed} element={<PaymentFailed/>} />
              </Routes>
            </MuiThemeProvider>
          </StyledThemeProvider>
        </BrowserRouter>
      </Provider>
    </Box>
  );
};

const App = () => {
  // Initialize Google Analytics with error handling
  try {
    if (GA_ID) {
      ReactGA.initialize(GA_ID);
    } else {
      console.warn('Google Analytics ID not provided, analytics will be disabled');
    }
  } catch (error) {
    console.error('Failed to initialize Google Analytics:', error);
  }

  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
};

export default App;
